import { Box, CardMedia, Typography } from '@mui/material';
import React from 'react';
import './Partnerships.css'

const Partnerships = () => {
    return (
        <div>
            <Box sx={{ display: 'flex', alignItems: 'center', py: '20px' }}>
                <Box className="first-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#4741E4' }}></Box>
                <Box className="second-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#7E89FF' }}></Box>
                <Typography sx={{ fontFamily: 'poppins', fontWeight: 700, fontSize: { xs: '20px', sm: '22px', md: '25px', lg: '30px' }, lineHeight: { xs: '30px', lg: '45px' }, color: '#433ED1', textAlign: 'left', pl: { xs: '18px', sm: '22px', md: '28px', lg: '36px' } }}>
                    Partnerships
                </Typography>
            </Box>

            {/* partner logo */}
            <Box sx={{ pt: '10px', pb: { xs: '20px', md: '28px' } }}>
                <CardMedia
                    className="image-hover"
                    component="img"
                    sx={{ width: { xs: '98px', sm: '140px', md: '165px', lg: '238px' }, mx: 'auto', px: { xs: '29px', sm: '35px', md: '45px', lg: '60px' }, py: { xs: '10px', sm: '14px', md: '16px', lg: '20px' }, border: '0.413423px solid #F0F0FF', borderRadius: '6px' }}
                    image="https://i.ibb.co/4Fmw5X7/partnership.png"
                    alt="logo"
                />
            </Box>
        </div>
    );
};

export default Partnerships;